<template>
    <dashboard-layout fullHeight>
        <template slot="title">
            <v-row no-gutters align="center">
                <v-col cols="auto"> <h3 class="tit grey-c--text">채용관리</h3> </v-col>
                <v-col cols="auto"> <span class="tit__line" /> </v-col>
                <v-col cols="auto">
                    <h3 class="tit">{{ recruitment?.subject }}</h3>
                </v-col>
            </v-row>
        </template>
        <template slot="contents">
            <v-row align-md="center" class="mb-n4 mb-md-12" style="flex: 0 0 auto">
                <v-col cols="12" class="mb-10 mb-md-0">
                    <v-badge floating dot class="v-badge--btn">
                        <v-btn text @click="$router.go(-1)">
                            <i class="icon icon-left-arrow mr-4 mr-lg-8" />
                            <h4 class="tit--sm line-height-1">합격자 관리</h4>
                        </v-btn>
                    </v-badge>               
                </v-col>
                <v-col cols="12" class="mb-12 mb-lg-0">
                    <v-row justify-lg="end" align="center" class="row--small">
                        <v-col cols="12" md="">
                            <v-btn text class="v-btn--text-fit" @click="toggleAllSelected"> <v-simple-checkbox :value="isAllSelected" @click="toggleAllSelected" /> 전체선택 </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4" md="auto">
                            <meeting-view :value="{ recruitment, applications: selected }">
                                <template #activator="{ attrs, on }">
                                    <v-btn outlined small v-bind="attrs" v-on="on" color="grey-d" class="w-100 w-md-160px">
                                        <span class="grey-6--text"> 선택항목 미팅요청 <v-icon size="18" class="ml-4">mdi-calendar</v-icon> </span>
                                    </v-btn>
                                </template>
                            </meeting-view>
                        </v-col>
                        <v-col cols="6" sm="4" md="auto">
                            <texting-dialog v-model="selected" :applications="recruits" :paramsProps="{ _recruitment }" v-bind="{ recruitment }">
                                <template #activator="{ attrs, on }">
                                    <v-btn outlined small v-bind="attrs" v-on="on" color="grey-d" class="w-100 w-md-160px">
                                        <span class="grey-6--text"> 선택항목 문자발송 <v-icon size="18" class="ml-4">mdi-email-outline</v-icon> </span>
                                    </v-btn>
                                </template>
                            </texting-dialog>
                        </v-col>
                        <v-col cols="12" sm="4" md="auto">
                            <application-excel-btn :fileName="`${recruitment?.subject}_합격자_목록`" v-bind="{ selected }" small dark color="green" class="w-100 w-md-160px">
                                <span> 엑셀파일 다운로드 <v-icon size="18" class="ml-4">mdi-tray-arrow-down</v-icon> </span>
                            </application-excel-btn>
                        </v-col>
                    </v-row>
                </v-col>

                <v-spacer />
                <!-- <v-col cols="auto">
                    <meeting-view :value="{ recruitment, applications: selected }">
                        <template #activator="{ attrs, on }">
                            <v-btn outlined small class="px-24" v-bind="attrs" v-on="on">
                                <span> 선택항목 미팅요청 <v-icon small>mdi-calendar</v-icon> </span>
                            </v-btn>
                        </template>
                    </meeting-view>
                </v-col>
                <v-col cols="auto">
                    <texting-dialog v-model="selected" :applications="recruits" :paramsProps="{ _recruitment }" v-bind="{ recruitment }">
                        <template #activator="{ attrs, on }">
                            <v-btn outlined small class="px-24" v-bind="attrs" v-on="on">
                                <span> 선택항목 문자발송 <v-icon small>mdi-email-outline</v-icon> </span>
                            </v-btn>
                        </template>
                    </texting-dialog>
                </v-col>
                <v-col cols="auto">
                    <application-excel-btn :fileName="`${recruitment?.subject}_합격자_목록`" v-bind="{ selected }" small dark color="green darken-3" class="px-24">
                        <span> 엑셀파일 다운로드 <v-icon small>mdi-arrow-collapse-down</v-icon> </span>
                    </application-excel-btn>
                </v-col> -->
            </v-row>
            <div class="v-cards">
                <recruit-list-item v-for="value in recruits" :key="value?._id" v-bind="{ value, selected, recruitment }" @input="updateItem" @updateSelected="(value) => (selected = value)" />
            </div>
            <template v-if="!recruits.length">
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        합격자가 없습니다.
                    </p>
                    <v-btn text height="auto" color="transparent" @click="$router.go(-1)">
                        <span class="grey-9--text">채용리스트 돌아가기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_KANBAN_FIELDS } from "@/assets/variables";

import MeetingView from "@/components/dashboard/company/meeting/view/meeting-view.vue";
import TextingDialog from "@/components/dashboard/company/texting/texting-dialog.vue";
import RecruitListItem from "@/components/dashboard/company/recruit/recruit-list-item.vue";
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ApplicationExcelBtn from "@/components/dashboard/company/application/application-excel-btn.vue";

const fields = Object.values(RECRUITMENT_KANBAN_FIELDS);

const initStage = () => fields.reduce((stage, { value }) => ({ ...stage, [value]: [] }), {});

export default {
    components: {
        MeetingView,
        TextingDialog,
        RecruitListItem,
        DashboardLayout,
        ApplicationExcelBtn,
    },
    props: {
        _recruitment: { type: String },
    },
    data: () => ({
        loading: false,

        kanban: undefined,
        recruitment: undefined,
        applications: [],
        stage: initStage(),

        selected: [],
    }),
    computed: {
        recruits() {
            return this.stage?.[RECRUITMENT_KANBAN_FIELDS.RECRUIT.value] || [];
        },
        isAllSelected() {
            return !this.recruits.some(({ _id }) => !this.selected.some((item) => item?._id == _id));
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loading = false;

            this.kanban = undefined;
            this.recruitment = undefined;
            this.applications = [];
            this.stage = initStage();

            this.selected = [];

            this.search();
        },
        async search() {
            this.loading = true;
            try {
                var { kanban, recruitment, applications } = await api.v1.company.recruitments.kanban.get({ _recruitment: this._recruitment });
                this.kanban = kanban;
                this.recruitment = recruitment;
                this.applications = applications;
                this.setStage();
            } finally {
                this.loading = false;
            }
        },
        setStage() {
            for (const { value: key } of fields) {
                this.stage[key] = (this.kanban?._applications?.[key] || []).map((_id) => this.applications.find((item) => item._id == _id));
            }
        },
        updateItem(item) {
            const index = this.applications.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.applications.splice(index, 1, item);
            this.setStage();
        },
        toggleAllSelected() {
            if (this.isAllSelected) this.selected = [];
            else this.selected = [...this.recruits];
        },
    },
};
</script>

<style lang="scss" scoped></style>
